import { useMemo, useState } from 'react'
import condIterkaImage from '../../../assets/images/conditerka.png'
import paulinaImage from '../../../assets/images/paulina.png'
import secretImage from '../../../assets/images/secret.png'
import dubaiImage from '../../../assets/images/dubai.png'
import inst from '../../../assets/images/inst.svg'
import tg from '../../../assets/images/tg.svg'
import triangle from '../../../assets/images/triangle.png'

interface RecommendedChannelsProps {
  defaultOpen?: boolean
}

type ChannelItem = {
  id: string
  title: string
  subtitle?: string
  text?: string
  bullets?: string[]
  buttonText: string
  href: string
  image?: string
  icon?: boolean
}

const RecommendedChannels = ({
  defaultOpen = false,
}: RecommendedChannelsProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(defaultOpen)

  const channels = useMemo<ChannelItem[]>(
    () => [
      {
        id: 'free-telegram',
        title: 'Кондитерка',
        subtitle: 't.me/pauline_cake_club',
        text: 'Бесплатный Telegram-канал',
        image: condIterkaImage,
        icon: true,
        bullets: [
          'Ежедневные подборки трендовых находок',
          '«Распаковка» тем недели из Secret Chat',
          'Правила приготовления и экспертные инсайты',
          'Вдохновение',
          'Бесплатные гайды, чек-листы и рецепты',
        ],
        buttonText: 'Вступить',
        href: 'https://t.me/pauline_cake_club',
      },
      {
        id: 'pauline-instagram',
        title: 'Pauline Cake',
        subtitle: '@pauline_cake',
        text: 'Личный Instagram-аккаунт Полины\u00A0',
        image: paulinaImage,
        buttonText: 'Подписаться',
        href: 'https://instagram.com/pauline_cake',
      },
      {
        id: 'secretchat-instagram',
        title: 'Secret Chat Instagram',
        subtitle: '@pauline_secret_chat',
        text: 'Instagram-аккаунт базы рецептов Pauline Cake',
        image: secretImage,
        bullets: [
          'Анонсы предстоящих недель',
          'Экспертные разборы рецептов, инструментов, кейсов и ведения бизнеса',
          'Море кондитерской эстетики',
        ],
        buttonText: 'Подписаться',
        href: 'https://instagram.com/pauline_secret_chat',
      },
      {
        id: 'dubai-instagram',
        title: 'Pauline Cake Dubai',
        subtitle: '@pauline_cake_dubai',
        text: 'Instagram-аккаунт кондитерского цеха в Дубае',
        image: dubaiImage,
        bullets: [
          'Закулисье производства',
          'Процесс приготовления',
          'Эффектные торты и десерты для клиентов',
        ],
        buttonText: 'Подписаться',
        href: 'https://instagram.com/pauline_cake_dubai',
      },
    ],
    []
  )

  const handleToggle = () => setIsOpen(prev => !prev)

  const openExternal = (url: string) => {
    try {
      window.open(url, '_blank')
    } catch (_) {
      // noop
    }
  }

  return (
    <div className="recommended-channels">
      <button
        className="recommended-header"
        onClick={handleToggle}
        aria-expanded={isOpen}
      >
        <span className="recommended-title">Также рекомендуем заглянуть</span>
        <span className={`collapse-icon ${isOpen ? '' : 'collapsed'}`}>
          <img src={triangle} alt="collapse" className="collapse-icon-img" />
        </span>
      </button>

      {isOpen && (
        <div className="recommended-list">
          {channels.map(ch => (
            <div key={ch.id} className="recommended-card">
              <div className="recommended-card-header">
                {ch.image && (
                  <img
                    src={ch.image}
                    alt={ch.title}
                    className="recommended-avatar"
                  />
                )}
                <div className="recommended-headings">
                  <p className="recommended-name">{ch.title}</p>
                  {ch.subtitle && (
                    <div className="recommended-icon-block">
                      {ch.icon ? (
                        <img className="recommended-icon" src={tg} alt="" />
                      ) : (
                        <img className="recommended-icon" src={inst} alt="" />
                      )}
                      <p className="recommended-subtitle">
                        <span>{ch.subtitle}</span>
                      </p>
                    </div>
                  )}
                </div>
              </div>

              {ch.text && <p className="recommended-text">{ch.text}</p>}

              {ch.bullets && ch.bullets.length > 0 && (
                <ul className="recommended-bullets">
                  {ch.bullets.map((b, i) => (
                    <li key={i}>{b}</li>
                  ))}
                </ul>
              )}

              <button
                className="recommended-action"
                onClick={() => openExternal(ch.href)}
              >
                {ch.buttonText}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default RecommendedChannels
